export const initialState = {}

// TODO remove with ft brandPage - added 17/06/2020 by @mikediam
export const set = (state, payload) => payload
